import { makeStyles } from '@mui/styles';
import React from 'react';
import { NavLink } from 'react-router-dom';
import useIsPrivate from '../../hooks/useIsPrivate';

const useStyles = makeStyles((theme) => ({
  header__nav: {
    position: 'sticky',
    width: '100%',
    margin: '0 auto',
    textTransform: 'uppercase',
    fontSize: 15,
    '& ul': {
      listStyleType: 'none',
      display: 'grid',
      gridTemplateColumns: 'repeat(5,1fr)',
      padding: 0,
      margin: 0,
      '& li': {
        color: '#fff',
        textDecoration: 'none',
        width: '100%',
        textAlign: 'center',
        transition: 'opacity .5s',
        display: 'flex',
        '& a': {
          color: '#fff',
          textDecoration: 'none',
          width: '100%',
          textAlign: 'center',
          padding: '10px 5px',
          '&:hover': {
            cursor: 'pointer',
            opacity: '.7',
          },
        },
      },
    },
  },
}));
const Menu = () => {
  const classes = useStyles();

  const isPrivate = useIsPrivate();

  if (!isPrivate) {
    return null;
  }

  return (
    <nav className={classes.header__nav}>
      <ul>
        <li style={{ background: '#407aac' }}>
          <NavLink to="/associati/news"> News </NavLink>
        </li>
        <li style={{ background: '#739dc2' }}>
          <NavLink to="/associati/materiale"> Materiale eventi </NavLink>
        </li>
        <li style={{ background: '#8cafcd' }}>
          <NavLink to="/associati/report"> Report & studi </NavLink>
        </li>
        <li style={{ background: '#a6c1d8' }}>
          <NavLink to="/associati/convenzioni"> Convenzioni </NavLink>
        </li>
        <li style={{ background: '#b3d0e9' }}>
          <NavLink to="/associati/documenti"> Documentazione Assonave </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default Menu;
